<template>
    <div>
        <page-title :title="integration.name"></page-title>

        <form-section @submitted="updatePassword">
            <template #title>
                {{ $t('integrations.editTitle') }}
            </template>

            <template #description>
                {{ $t('integrations.editDescription') }}
            </template>

            <template #form>
                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="name" :value="$t('integrations.name')"/>
                    <jet-input id="name" type="text" class="mt-1 block w-full"
                               v-model="form.name"
                               ref="name"/>
                    <jet-input-error :message="form.errors.name" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="code" :value="$t('integrations.code')"/>
                    <jet-input id="code" type="text" class="mt-1 block w-full"
                               v-model="form.code"
                               ref="code"/>
                    <jet-input-error :message="form.errors.code" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="integration" :value="$t('integrations.integration')"/>
                    <jet-input id="integration" type="text" class="mt-1 block w-full"
                               v-model="form.integration"
                               ref="integration"/>
                    <jet-input-error :message="form.errors.integration" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="active" :value="$t('integrations.active')"/>
                    <checkbox id="active"
                              :value="$t('integrations.active')"
                              v-model:checked="form.active"></checkbox>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="handles_orders" :value="$t('integrations.handles_orders')"/>
                    <checkbox id="handles_orders"
                              :value="$t('integrations.handles_orders')"
                              v-model:checked="form.handles_orders"></checkbox>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="manages_payments" :value="$t('integrations.manages_payments')"/>
                    <checkbox id="manages_payments"
                              :value="$t('integrations.manages_payments')"
                              v-model:checked="form.manages_payments"></checkbox>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="color" :value="$t('integrations.color')"/>
                    <jet-input id="color" type="text" class="mt-1 block w-full"
                               v-model="form.color"
                               ref="color"/>
                    <jet-input-error :message="form.errors.color" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="locale" :value="$t('integrations.locale')"/>
                    <jet-input id="locale" type="text" class="mt-1 block w-full"
                               v-model="form.locale"
                               ref="locale"/>
                    <jet-input-error :message="form.errors.locale" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="currency" :value="$t('integrations.currency')"/>
                    <jet-input id="currency" type="text" class="mt-1 block w-full"
                               v-model="form.currency"
                               ref="currency"/>
                    <jet-input-error :message="form.errors.currency" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="user" :value="$t('integrations.user')"/>
                    <jet-input id="user" type="text" class="mt-1 block w-full"
                               v-model="form.user"
                               ref="user"/>
                    <jet-input-error :message="form.errors.user" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="password" :value="$t('integrations.password')"/>
                    <jet-input id="password" type="text" class="mt-1 block w-full"
                               v-model="form.password"
                               ref="password"/>
                    <jet-input-error :message="form.errors.password" class="mt-2"/>
                </div>

                <div class="col-span-6 sm:col-span-4">
                    <jet-label for="endpoint" :value="$t('integrations.endpoint')"/>
                    <jet-input id="endpoint" type="text" class="mt-1 block w-full"
                               v-model="form.endpoint"
                               ref="endpoint"/>
                    <jet-input-error :message="form.errors.endpoint" class="mt-2"/>
                </div>

            </template>

            <template #actions>
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                    {{ $t('actions.save') }}
                </jet-button>
            </template>
        </form-section>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout";
import PageTitle from "@/Shared/Components/PageTitle";
import FormSection from "@/Jetstream/FormSection";
import JetLabel from "@/Jetstream/Label";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetButton from "@/Jetstream/PrimaryButton";
import Checkbox from "@/Jetstream/Checkbox";
import {useForm} from "@inertiajs/vue3";

export default {
    props: ['integration'],
    layout: AppLayout,
    components: {
        PageTitle,
        FormSection,
        JetLabel,
        JetInput,
        JetInputError,
        JetButton,
        Checkbox
    },
    data() {
        return {
            form: useForm({
                name: this.integration.name,
                code: this.integration.code,
                integration: this.integration.integration,
                active: this.integration.active,
                handles_orders: this.integration.handles_orders,
                manages_payments: this.integration.manages_payments,
                color: this.integration.color,
                locale: this.integration.locale,
                reference: this.integration.reference,
                user: this.integration.user,
                password: this.integration.password,
                endpoint: this.integration.endpoint,
                currency: this.integration.currency,
            })
        }
    },

    methods: {
        updatePassword() {
            this.form.put(this.route('settings.integrations.update', this.integration.id), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "main",
                    title: 'actions.success',
                    text: 'integrations.updated'
                }, 2000)
            })
        },
    },
}
</script>

<style scoped>

</style>
